<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col sm="3" md="2" xl="2" style="padding-right: 0px; padding-left: 0px; padding-top: 0px; padding-bottom: 0px">
          <v-select
              v-model="mita_select_value"
              :items="mita_select"
              filled
              hide-details
              label="Darstellungsart"
              @change="unselectMitas"
          ></v-select>
        </v-col>
        <v-col sm="3" md="2" lg="2" xl="1" style="padding-left: 6px; padding-top: 0px; padding-bottom: 0px">
          <v-select
              :items="dateModes"
              v-model="currentMode"
              filled
              hide-details
          ></v-select>
        </v-col>
        <v-col sm="3" md="2" lg="2" xl="2" class="pt-0 pb-0">
          <v-row class="m-0">
            <v-col cols="9" class="p-0">
          <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="formatedDate"
                  label="Zeitraum"
                  prepend-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  style="margin-top: 12px"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                :type="currentMode === 'month' ? 'month' : 'date'"
                scrollable
                locale="de"
                :key="currentMode"
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="modal = false"
              >
                Abbrechen
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="setDate(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
            </v-col>
            <v-col cols="1" class="p-1 mr-2">
          <v-btn
              style="margin-top: 15px"
              icon
              color="dark-grey"
              @click="moveDate(-1)"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
            </v-col>
            <v-col cols="1" class="p-1">
          <v-btn
              style="margin-top: 15px"
              icon
              color="dark-grey"
              @click="moveDate(1)"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="p-0">
          <v-btn
              style="margin-top: 19px"
              icon
              color="blue"
              @click="changeMitas"
          >
            <v-icon>mdi-refresh-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col sm="3" md="2" xl="2" style="padding-left: 0px; padding-right: 0px; padding-top: 0px; padding-bottom: 0px">
          <v-select
              v-model="tasks_select_value"
              :items="tasks_select"
              filled
              hide-details
              label="Darstellungsart"
              @change="onTaskSelectChange"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="m-0">
        <v-col sm="3" md="2" xl="2" style="padding-right: 0px; padding-left: 0px">
          <v-text-field v-if="mita_select_value === 'Mitarbeiter'" prepend-inner-icon="mdi-magnify"
                        hide-details single-line filled label="Suchen" v-model="search" clearable
                        @click:clear="clearSearch"></v-text-field>
          <v-list v-if="mita_select_value === 'Mitarbeitergruppen'" style="max-height: 85vh; overflow-y: auto">
            <v-list-group
                v-for="(kost, j) in filteredKosts"
                :key="'KOST-' + kost.gischl"
                @click=""
            >
              <template v-slot:activator>
                <v-list-item-icon style="margin-right: 12px">
                  <v-btn
                      icon
                      :color="currentMitas.filter(v => {return v === 'KOST-' + kost.gischl + '-'}).length ? 'deep-purple accent-4' : 'dark-grey'"
                      @click.stop.prevent="onMitaClicked('KOST-' + kost.gischl + '-', 'kosts', $event)"
                  >
                    <v-icon v-text="currentMitas.filter(v => {return v === 'KOST-' + kost.gischl + '-'}).length ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'"></v-icon>
                  </v-btn>
                </v-list-item-icon>
                <v-list-item-title v-text="kost.name"></v-list-item-title>
              </template>
              <v-list-group
                  v-for="(migr, i) in sortedMigrs(kost.name)"
                  :key="'MIGR-' + migr.gischl"
                  @click=""
                  sub-group
              >
                <template v-slot:activator>
                  <v-list-item-icon style="margin-right: 12px">
                    <v-btn
                        icon
                        :color="currentMitas.filter(v => {return v === 'MIGR-' + migr.gischl + '-'}).length ? 'deep-purple accent-4' : 'dark-grey'"
                        @click.stop.prevent="onMitaClicked('MIGR-' + migr.gischl + '-', 'migrs', $event)"
                    >
                      <v-icon v-text="currentMitas.filter(v => {return v === 'MIGR-' + migr.gischl + '-'}).length ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'"></v-icon>
                    </v-btn>
                  </v-list-item-icon>
                  <v-list-item-title v-text="migr.name"></v-list-item-title>
                </template>
              <v-list-item-group
                  v-model="currentMitas"
                  multiple>
                <v-list-item
                    v-for="(mita, i) in sortedItems(migr.name)"
                    :key="mita.bis_id+ '-'"
                    :value="mita.bis_id+ '-'"
                    @click.capture.stop="onMitaClicked(mita.bis_id+ '-', migr.name, $event)"
                    active-class="remove-background"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                          :input-value="active"
                          color="deep-purple accent-4"
                          @click.capture.stop="onMitaClicked(mita.bis_id+ '-', migr.name, $event)"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-text="mita.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
              </v-list-group>
            </v-list-group>
            <v-list-group
                v-for="(migr, j) in filteredMigrs"
                :key="migr"
                @click=""
            >
              <template v-slot:activator>
                <v-list-item-icon style="margin-right: 12px">
                  <v-btn
                      icon
                      :color="currentMitas.filter(v => {return v === migr}).length ? 'deep-purple accent-4' : 'dark-grey'"
                      @click.stop.prevent="onMitaClicked(migr, 'migrs', $event)"
                  >
                    <v-icon v-text="currentMitas.filter(v => {return v === migr}).length ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'"></v-icon>
                  </v-btn>
                </v-list-item-icon>
                <v-list-item-title v-text="migr"></v-list-item-title>
              </template>
              <v-list-item-group
                  v-model="currentMitas"
                  multiple>
                <v-list-item
                    v-for="(mita, i) in sortedItems(migr)"
                    :key="mita.bis_id+ '-'"
                    :value="mita.bis_id+ '-'"
                    @click.capture.stop="onMitaClicked(mita.bis_id+ '-', migr, $event)"
                    active-class="remove-background"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                          :input-value="active"
                          color="deep-purple accent-4"
                          @click.capture.stop="onMitaClicked(mita.bis_id+ '-', migr, $event)"
                      ></v-checkbox>
                    </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-text="mita.name"></v-list-item-title>
                  </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
          </v-list>
          <v-list v-else style="max-height: 79vh; overflow-y: auto">
            <v-list-item-group
                v-model="currentMitas"
                color="primary"
                multiple
            >
              <v-list-item
                  v-for="(mita, i) in filteredItems"
                  :key="mita.bis_id+'-'"
                  :value="mita.bis_id+'-'"
                  @click.capture.stop="onMitaClicked(mita.bis_id+'-', 'filteredItems', $event)"
                  active-class="remove-background"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox
                        :input-value="active"
                        color="deep-purple accent-4"
                        @click.capture.stop="onMitaClicked(mita.bis_id+'-', 'filteredItems', $event)"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-text="mita.name"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <!--v-list-item-content>
                  <v-list-item-title v-text="mita.name"></v-list-item-title>
                </v-list-item-content-->
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col style="padding-left: 6px; padding-right: 6px">
          <v-card
              style="width: 100%;
    height: 85vh;
    display: flex;
    flex-direction: column;
    min-height: 0;">
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="blue"
                :weekday-format="myDayFormat"
                :month-format="myMonthFormate"
                :weekdays="weekdayOrder"
                :events="calendarEvents"
                :type="currentMode.startsWith('5') ? 'week' : currentMode"
                event-more-text="Mehr anzeigen"
                :class="{'five-week': currentMode === '5week'}"
                interval-count="1"
                :interval-height="intervalHeight"
                interval-minutes="1440"
                :event-color="getEventColor"
                @mousedown:event="startDragEvent"
                @mousedown:time="startTime"
                @mousemove:time="mouseMove"
                @mouseup:time="endDrag"
                @click:event="editEvent"
                @mouseleave.native="cancelDrag"

            >
              <template v-slot:day="{ date, time, year, month, day, weekday, outside}">
                <div style="height: 100%; width: 100%;"
                     @drop="onDrop($event, date, weekday)"
                     @dragover.prevent
                     @dragenter.prevent v-if="!outside">

                </div>
              </template>
              <template v-slot:day-label="{date, day, present, month, weekday}">
                <v-row class="m-0" style="margin-top: -6px !important;"
                       @drop="onDrop($event, date, weekday)"
                       @dragover.prevent
                       @dragenter.prevent>
                  <v-col md="9" class="p-1 text-left">
                    <v-chip
                        v-if="date in holidays"
                        class="soll-ist zero text-truncate"
                        label small
                    >
                      {{ holidays[date] }}
                    </v-chip>
                  </v-col>
                  <v-col v-if="!present" md="3" class="p-1">
                    <v-btn fab x-small depressed>{{ day }}</v-btn>
                  </v-col>
                  <v-col v-else md="3" class="p-1 text-left">
                    <v-btn fab x-small depressed color="#63c2de">{{ day }}</v-btn>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:day-header="{date, day, present, month}">
                <v-row class="m-0" style="margin-top: -6px !important;">
                  <v-col class="p-1 text-center" v-if="date in holidays">
                    <v-chip
                        class="soll-ist zero text-truncate" style="width: 100%; text-align: center"
                        label small
                    >
                      {{ holidays[date] }}
                    </v-chip>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:day-label-header="{date, day, present, month, weekday}">
                <v-row class="m-0" style="margin-top: -6px !important;"
                       @drop="onDrop($event, date, weekday)"
                       @dragover.prevent
                       @dragenter.prevent>
                  <v-col v-if="!present" class="p-1 text-center">
                    <v-btn fab x-small depressed>{{ pad(day, 2) + '.' + pad(month, 2) }}</v-btn>
                  </v-col>
                  <v-col v-else class="p-1 text-center">
                    <v-btn fab x-small depressed color="#63c2de">{{ pad(day, 2) + '.' + pad(month, 2)}}</v-btn>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:interval="{ date, time, year, month, day, weekday }">
                <div style="height: 100%; width: 100%;"
                      @drop="onDrop($event, date, weekday)"
                     @dragover.prevent
                     @dragenter.prevent>

                </div>
              </template>
              <template v-slot:event="{ event, timed, eventSummary, day}" >
                <div  :class="{'clickable': currentMode !== 'month', 'v-event-draggable': currentMode !== 'month', 'clickable-month': currentMode === 'month', 'unselectable-text': true}"
                      @drop="onDrop($event, day.date, day.weekday)"
                      @dragover.prevent
                      @dragenter.prevent>
                  <!--component :is="{ render: eventSummary }"></component-->
                  <v-row style="margin: 0; flex-grow: 0" v-if="currentMode !== 'month'">
                    <v-icon small :color="event.finishedBy.length === 0 ? 'black' : 'white'"
                            v-text="event.type === 'task' ? 'mdi-calendar-check' : (event.type === 'quick' ? 'mdi-clipboard-account-outline' : 'mdi-transit-detour')"
                    >
                    </v-icon>
                    <p class="mb-0 ml-1 text-center" :style="{'color': event.finishedBy.length === 0 ? 'black' : 'white'}">
                      {{event.type === 'tour' ? 'Tour' : (event.type === 'task' ? 'Aufgabe' : (event.type === 'quick' ? 'Stammauftrag' : event.task_message))}}
                    </p>
                  </v-row>
                  <div :class="{'v-event-summary': true, 'event-extended': currentMode !== 'month'}" :style="{'color': event.finishedBy.length === 0 ? 'black' : 'white'}"><b>{{event.name}}</b></div>
                  <p class="event-description" :style="{'color': event.finishedBy.length === 0 ? 'black' : 'white'}" v-if="currentMode !== 'month'">{{event.description}}</p>
                  <v-row style="margin: 0; flex-grow: 0" v-if="currentMode !== 'month' && event.plannedFor.length">
                    <v-icon small :color="event.finishedBy.length === 0 ? 'black' : 'white'" style="align-items: start; padding-top: 2px;"
                            v-text="'mdi-account-supervisor-circle'">
                    </v-icon>
                    <v-col cols="10" class="p-0">
                    <p :class="{'mb-0': true,  'ml-1': true, 'planned-for': true, 'event-description': event.finishedBy.length === 0}"
                       :style="{'color': event.finishedBy.length === 0 ? 'black' : 'white'}">{{event.plannedFor.join(', ')}}</p>
                    </v-col>
                  </v-row>
                  <v-row style="margin: 0; flex-grow: 0" v-if="currentMode !== 'month' && event.finishedBy.length">
                    <v-icon small color="white" style="align-items: start; padding-top: 2px;"
                            v-text="'mdi-checkbox-marked-circle'">
                    </v-icon>
                    <v-col cols="10" class="p-0">
                      <p :class="{'mb-0': true,  'ml-1': true, 'planned-for': true, 'event-description': event.plannedFor.length === 0}">{{event.finishedBy.join(', ')}}</p>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </v-calendar>
          </v-card>
          <v-overlay
              absolute
              :value="currentMitas.length === 0"
              style="margin: 13px 6px 18px;"
              opacity="0.1"
          >
            <v-row>
              <v-col>
                <!--p class="h3">Bitte wählen Sie zuerst einen Mitarbeiter aus.</p-->
              </v-col>
            </v-row>
          </v-overlay>
        </v-col>
        <v-col sm="3" md="2" xl="2" style="padding-left: 0px; padding-right: 0px">
          <v-row class="m-0">
            <v-col class="p-0"> <v-text-field prepend-inner-icon="mdi-magnify" ref="searchTasks"
                                  hide-details single-line filled label="Suchen" v-model="debounced" clearable
                                  @click:clear=""></v-text-field></v-col>
            <v-col cols="2" class="p-0 text-center" v-if="tasks_select_value !== 'predef'">
              <v-btn
                  fab
                  small
                  depressed
                  tile
                  :class="{'my-filter': true, 'inactive': !hasTaskFilters}"
                  :color="hasTaskFilters ? '#2196F3' : 'rgba(0, 0, 0, 0.06)'"
                  style="height: 100%; width: 100%;"
                  @click="openFilter"
              >
                <v-icon v-text="hasTaskFilters ? 'mdi-filter' : 'mdi-filter-outline'"></v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-list v-if="tasks_select_value === 'stamm'" style="max-height: 79vh; overflow-y: auto" :key="selectedDistrict">
            <v-list-group
                v-for="augr of filteredAugrs"
                v-model="augr.active"
                no-action
                :key="augr.id"
            >
              <template v-slot:activator>
                <v-list-item-title ><b>{{augr.name}}</b></v-list-item-title>
              </template>
                <v-list-item
                    v-for="(stamm, i) in sortedStamms(augr)"
                    :key="stamm.id"
                    :value="stamm.id"
                    active-class="remove-background"
                    @click.prevent.stop=""
                    :ripple="false"
                    class="drag-el rounded"
                    draggable="true"
                    style="cursor: pointer"
                    @dragstart="startDrag($event, stamm)"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title v-text="stamm.object"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
            </v-list-group>
          </v-list>
          <v-list v-else-if="tasks_select_value !== 'predef'" style="max-height: 79vh; overflow-y: auto">
            <v-list two-line rounded style="padding: 2px 0px 0px;">
              <v-list-item-group
                  no-action
              >
                  <v-list-item v-for="task of filteredTasks"
                      :key="task.id"
                               :value="task.id"
                               active-class="remove-background"
                               :ripple="false"
                               @click.pre.prevent.stop=""
                               class="drag-el"
                               draggable="true"
                               style="cursor: pointer"
                               @dragstart="startDrag($event, task)">
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-row style="margin: 0; flex-grow: 1;">
                          <v-icon v-if="(task.count_open + task.count_finished) > 0" small style="align-items: start; color: rgba(0, 0, 0, 0.6);"
                                  v-text="'mdi-account-circle-outline'">
                          </v-icon>
                          <p v-if="(task.count_open + task.count_finished) > 0" style="margin: 0; line-height: 16px; color: rgba(0, 0, 0, 0.6);">{{task.count_open + task.count_finished}}</p>
                          <v-col style="padding: 0"></v-col>
                          <v-list-item-action-text style="text-align: right" v-text="task.ziel_datum.split('T')[0].split('-').reverse().join('.')"></v-list-item-action-text>
                        </v-row>
                        <v-list-item-title  class="event-description" v-text="task.subject"></v-list-item-title>
                        <v-list-item-subtitle class="event-description" v-text="task.description"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-list>
          <v-list v-else style="max-height: 79vh; overflow-y: auto">
            <v-list two-line rounded style="padding: 2px 0px 0px;">
              <v-list-item-group
                  no-action
              >
                  <v-list-item v-for="predef of filteredPredefs"
                      :key="predef.id"
                               :value="predef.id"
                               active-class="remove-background"
                               :ripple="false"
                               @click.pre.prevent.stop=""
                               class="drag-el"
                               draggable="true"
                               style="cursor: pointer"
                               @dragstart="startDrag($event, predef)">
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title  class="event-description" v-text="predef.name"></v-list-item-title>
                        <v-list-item-subtitle class="event-description" v-text="predef.description"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-list>
        </v-col>
      </v-row>
    </div>
    <quick-task-dialog ref="quick_task_modal"
                       :legrs="legrs" :possible-users="possibleUsers"
                       :task="currentTask" :tour_data="tourData"
                       @submit="upsertQuickTask" @delete="deleteQuickTask"
                       @show_tour="showTourOverView"
    />
    <quick-task-filter ref="quick_task_filter" :districts="districtSelect" @submit="setQuickTaskFilter"/>
    <task-filter ref="task_filter" :bh-structure="bhStructure" :task-types="taskTypes" :mode="tasks_select_value" @submit="setTasksFilter"/>
    <plan-predef-dialog ref="plan_predef_dialog" :bh-structure="bhStructure" :predef="currentPredef" @submit="onPlanTour"/>
    <tour-overview-dialog ref="tour_overview_dialog" :tour_data="tourData" :tour="tour"  @cancel=""/>
  </v-main>
</template>

<script>

import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";

import _orderBy from "lodash/orderBy"

import _throttle from "lodash/throttle"
import _debounce from "lodash/debounce"
import {decryptAES, decryptEvent, encryptAES} from "@/shared/crypto";
import QuickTaskDialog from "@/views/planning/QuickTaskDialog.vue";
import QuickTaskFilter from "@/views/planning/QuickTaskFilter.vue";
import TourOverviewDialog from "@/views/planning/TourOverviewDialog.vue";
import TaskFilter from "@/views/planning/TaskFilter.vue";
import {v4} from "uuid";
import PlanPredefDialog from "@/views/planning/PlanPredefDialog.vue";

const normalColor = "#eaeaea";
const partlyColor = "#5d725d";
const finishedColor = "#016d03";

export default {
  name: "Planning",
  components: {
    QuickTaskDialog,
    QuickTaskFilter,
    TaskFilter,
    PlanPredefDialog,
    TourOverviewDialog
  },
  data: () => ({
    mita_select: ['Mitarbeitergruppen', 'Mitarbeiter'],
    mita_select_value: 'Mitarbeiter',
    focus: '',
    kosts: [],
    migr_map: {},
    migrs: [],
    mitas: [],
    mitasFlat: [],
    holidays: [],
    overlay: true,
    currentMitas: [],
    search: '',
    searchTasks: '',

    date: new Date().toISOString().substr(0, 10),
    modal: false,
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["", "Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    dateModes: [{text: "Tag", value: "day"}, {text: "5 Tage", value: "5week"}, {text: "Woche", value: "week"}, {text: "Monat", value: "month"}],
    currentMode: "5week",
    currentMonth: 0,
    currentYear: 0,
    currentMitaSaves: [],
    events: [],
    calendarEvents: [],

    // task section
    tasks_select: [{text: "Aufgaben", value: "tasks"},{text: "Objekte", value: "stamm"},{text: "Touren mit Termin", value: "tours"}, {text: "Vorgefertigte Touren", value: "predef"}],
    tasks_select_value: 'stamm',
    hasTaskFilters: false,
    augrs: [],
    expandedAugrs: {},
    stamms: {},
    districtSelect: [],
    selectedDistrict: '',
    legrs: [],
    ro: null,
    dayInterValHeight: 0,
    debounced: '',
    possibleUsers: [],
    currentTask: {},

    // aufgaben/tour section
    bhStructure: [],
    taskFilter: {
      planned: "U", // A, P, U
      selectedKostMigr: "all", // all or id
      timeInterval: 1, // +- weeks to current date
      taskType: "all", // all, ab, bk, etc
    },
    possibleTabs: {
      "bk": false,
      "ft": false,
      "gps": false,
      "mm": false,
      "sp": false,
      "st": false
    },
    tasks: [],
    listModel: null,
    tourData: [],
    tour: {},
    predefined_tours: [],
    currentPredef: {},
    currentPredefFrom: null,
    resTour: null,

    // ordering
    dragEvent: null,
    dragStart: null,
    dragTime: null,
  }),
  watch: {
    currentMitas(newVal, oldVal) {
      if (this.search) {
        this.currentMitaSaves = [...newVal].concat(this.getNotFilteredItems(oldVal, this.currentMitaSaves));
      }
    },
    search(newVal, oldVal) {
      if (oldVal) {
        this.currentMitas = [...this.currentMitaSaves];
        if (!newVal) {
          this.currentMitaSaves = [];
        }
      }
    },
    debounced(newVal, oldVal) {
      // debounce search
      this.debounceInput(newVal);
    },
    focus(newVal, oldVal) {
      this.changeMitas();
      if (this.tasks_select_value === 'tasks' || this.tasks_select_value === 'tours') {
        this.queryTasks();
      }
    },
    currentMode(newVal, oldVal) {
      this.changeMitas();
      if (this.tasks_select_value === 'tasks' || this.tasks_select_value === 'tours') {
        this.queryTasks();
      }
    }
  },
  mounted() {
    this.$refs.calendar.updateTimes()
    this.currentMonth = this.$refs.calendar.parsedValue.month;
    this.currentYear = this.$refs.calendar.parsedValue.year;
    this.ro = new ResizeObserver(_throttle(() => {
      let ref = this.$refs.calendar.$el.getElementsByClassName('v-calendar-daily__scroll-area')[0];
      if (ref) {
        this.dayInterValHeight = ref.clientHeight;
      }
    }, 100));
    this.ro.observe(this.$refs.calendar.$el)
    this.$parent.$emit('close-side-bar');
  },
  beforeDestroy () {
    this.ro.unobserve(this.$refs.calendar.$el)
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL + '/auftragsbuch/planning?year=' + this.currentYear
    ).then(this.responseOkGet, this.responseError)
    this.$nextTick(() => {
      try {
        this.dayInterValHeight = this.$refs.calendar.$el.getElementsByClassName('v-calendar-daily__scroll-area')[0].clientHeight;
      } catch (e) {
        // ignore
      }
    });
  },
  computed: {
    taskTypes() {
      let res = [
          {text: "Alle", value: "all"},
          {text: "Aufträge", value: "ab"},
          ];
      if (this.possibleTabs["mm"]) {
        res.push({text: "Mängelmelder", value: "mm"});
      }
      if (this.possibleTabs["bk"]) {
        res.push({text: "Baumkontrolle", value: "bk"});
      }
      if (this.possibleTabs["ft"]) {
        res.push({text: "Fast-Task", value: "k5"});
      }
      if (this.possibleTabs["sp"]) {
        res.push({text: "Spielplatzkontrolle", value: "k1"});
      }
      if (this.possibleTabs["st"]) {
        res.push({text: "Straßenkontrolle", value: "k3"});
      }
      if (this.possibleTabs["gps"]) {
        res.push({text: "GPS-Nachweis", value: "k4"});
      }
      if (this.possibleTabs["series"]) {
        res.push({text: "Serienaufgaben", value: "series"});
      }
      return res;
    },
    formatedDate() {
      let splits = this.date.split("-");
      if (this.currentMode === 'month') {
        return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
      } else if (this.currentMode === 'day') {
        return splits[2] + ". " + this.monthsLong[parseInt(splits[1])] + " " + splits[0]
      } else {
        let date = new Date(parseInt(splits[0]), parseInt(splits[1]) - 1, parseInt(splits[2]));
        let week = this.getWeekNumber(date);
        let year = date.getFullYear();
        return "KW " + week + ", " + year;
      }
    },
    filteredItems() {
      return _orderBy(this.mitasFlat.filter(item => {
        if (!this.search) return this.mitasFlat;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },
    filteredTasks() {
      return _orderBy(this.tasks.filter(item => {
        if (!this.searchTasks) return this.tasks;
        return item.subject.toLowerCase().includes(this.searchTasks.toLowerCase()) || item.description.toLowerCase().includes(this.searchTasks.toLowerCase());
      }), 'ziel_datum');
    },
    filteredPredefs() {
      return _orderBy(this.predefined_tours.filter(item => {
        if (!this.searchTasks) return this.predefined_tours;
        return item.name.toLowerCase().includes(this.searchTasks.toLowerCase()) || item.description.toLowerCase().includes(this.searchTasks.toLowerCase());
      }), 'name');
    },
    filteredKosts() {
      return _orderBy(this.kosts, 'name');
    },
    filteredMigrs() {
      return _orderBy(this.migrs, 'name');
    },
    filteredAugrs() {
      if (!this.searchTasks && !this.selectedDistrict) {
        return this.augrs;
      }
      let filtered = _orderBy(this.augrs.filter(item => {
        if (this.selectedDistrict && !this.searchTasks) {
          return  this.sortedStamms(item).length > 0;
        } else if (this.searchTasks && !this.selectedDistrict) {
          return item.name.toLowerCase().includes(this.searchTasks.toLowerCase()) || this.sortedStamms(item).length > 0;
        } else {
          return this.sortedStamms(item).length > 0;
        }
      }), 'name');
      if (filtered.length === 1) {
        filtered[0].active = true;
      }
      return filtered;
    },
    countIntervals() {
      let eventCount = new Map();
      for (let i = 0; i < this.calendarEvents.length; i++) {
        if (eventCount.has(this.calendarEvents[i].date)) {
          eventCount.set(this.calendarEvents[i].date, eventCount.get(this.calendarEvents[i].date) + 1);
        } else {
          eventCount.set(this.calendarEvents[i].date, 1);
        }
      }
      let max = 0;
      for (let [key, value] of eventCount) {
        if (value > max) {
          max = value;
        }
      }
      return Math.max(6, max);
    },
    intervalHeight() {
      return Math.max(this.dayInterValHeight, this.countIntervals * 127);
    },
  },
  methods: {
    onTaskSelectChange() {
      if (this.tasks_select_value === 'stamm') {
        this.$refs.searchTasks.focus();
        this.hasTaskFilters = this.selectedDistrict !== '';
      } if (this.tasks_select_value === 'predef') {
        this.queryPredefinedTours();
        this.hasTaskFilters = false;
      } else  {
        this.queryTasks();
        this.hasTaskFilters = true;
      }
    },
    queryPredefinedTours() {
      this.$http.get(
          Server_URL+'/auftragsbuch/data/predefined_tour'
      ).then(this.responseOkPredefinedTours, this.responseError)
    },
    responseOkPredefinedTours(response) {
      if (response.status === 200) {
        let data = response.body.data;
        this.decryptPredefinedData(data);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    async decryptPredefinedData(data) {
      for (let i = 0; i < data.length; i++) {
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
        } catch (e) {
          //console.log(e)
        }
      }
      this.predefined_tours = data;
    },
    queryTasks() {
      let currentDate = new Date(this.date);
      let start, end;
      if (this.currentMode === 'month') {
        start = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        end = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      } else if (this.currentMode === 'week') {
        let day = currentDate.getDay();
        start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
        end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (7 - day));
      } else if (this.currentMode === '5week') {
        let day = currentDate.getDay();
        start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
        end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (5 - day));
      } else {
        start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      }
      start.setDate(start.getDate() - this.taskFilter.timeInterval * 7);
      end.setDate(end.getDate() + this.taskFilter.timeInterval * 7);
      start = encodeURIComponent(`${this.pad(start.getDate(), 2)}.${this.pad(start.getMonth() + 1, 2)}.${start.getFullYear()}`);
      end = encodeURIComponent(`${this.pad(end.getDate(), 2)}.${this.pad(end.getMonth() + 1, 2)}.${end.getFullYear()}`);
      this.$http.get(
          Server_URL+'/auftragsbuch/planning/tasks/'+this.taskFilter.selectedKostMigr+
          "?planning_state="+this.taskFilter.planned+
          "&selected_start_date="+start+
          "&selected_end_date="+end+
          "&module="+(this.tasks_select_value === 'tasks' ? this.taskFilter.taskType : 'planning')
      ).then(this.responseOkFetchTasks, this.responseError)
    },
    responseOkFetchTasks(response) {
      if (response.status === 200) {
        let data = response.body;
        if (this.resTour) {
          let found = false;
          for (let i = 0; i < data.length; i++) {
              if (data[i].id === this.resTour.id) {
                found = true;
                break;
              }
          }
          if (!found) {
            data.push(this.resTour);
          }
        }
        this.decryptData(data);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    async decryptData(data, append) {
      for (let i = 0; i < data.length; i++) {
        data[i]._showDetails = true;
        data[i].selected = false;
        data[i]._rowVariant = '';
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
        } catch (e) {
          //console.log(e)
        }
      }
      if (append) {
        if (data.length === 1) {
          // check if we have the task already
          let found = -1;
          for (let i = 0; i < this.tasks.length; i++) {
            if (this.tasks[i].id === data[0].id) {
              this.tasks[i] = data[0];
              found = true;
              break;
            }
          }
          if (!found) {
            this.tasks = this.tasks.concat(data);
          }
        } else {
          this.tasks = this.tasks.concat(data);
        }
      } else {
        this.tasks = data;
        if (this.resTour !== null) {
          for (let i = 0; i < this.tasks.length; i++) {
            if (this.tasks[i].id === this.resTour.id) {
              this.onDrop(null, this.currentPredef.till, "", this.tasks[i]);
              break
            }
          }
          this.resTour = null;
        }
      }
    },

    openFilter() {
      if (this.tasks_select_value === 'stamm') {
        this.$refs.quick_task_filter.show({selectedDistrict: this.selectedDistrict});
      } else {
        this.$refs.task_filter.show(this.taskFilter);
      }
    },
    setTasksFilter(filter) {
      this.taskFilter = {...filter};
      this.hasTaskFilters = true;
      this.queryTasks();
    },
    setQuickTaskFilter(filter) {
      this.selectedDistrict = filter.selectedDistrict;
      this.hasTaskFilters = filter.selectedDistrict !== '';
    },
    getEventById(id) {
      for (let i = 0; i < this.events.length; i++) {
        if (this.events[i].todo_id === id) {
          return this.events[i];
        }
      }
      return null;
    },
    editEvent({nativeEvent, event}) {
      let e = this.getEventById(event.id.split('||')[0]);
      this.possibleUsers = [];
      this.currentTask = {};
      this.tourData = [];
      for (let i = 0; i < this.currentMitas.length; i++) {
        this.possibleUsers.push({id: this.currentMitas[i], name: this.getNameForId(this.currentMitas[i])});
      }
      // order by name
      this.possibleUsers = _orderBy(this.possibleUsers, 'name');
      let plannedFor = [e.user_id];
      for (let i = 0; i < e.similar.length; i++) {
        plannedFor.push(e.similar[i].user_id);
      }
      let from, till;
      if (e.from) {
        from = e.from.split('T')[0]
      }
      till = e.till.split('T')[0]
      this.currentTask = {
        id: e.todo_id,
        task_id: e.task_id,
        task_name: e.task_subject,
        task_description: e.todo_message,
        from: from,
        till: till,
        planned_for: plannedFor,
        task_type: e.task_type,
        order: e.order,
      }
      this.$nextTick(() => {
        this.$refs.quick_task_modal.show();
      });
      nativeEvent.stopPropagation();
    },
    // dragging
    calculateOrder() {
      let currentDayEvents = _orderBy(this.calendarEvents.filter(event => event.date === this.dragEvent.date), 'start');
      // check the direction of the drag
      if (this.dragEvent.start < this.dragEvent.current_drag) {
        // travers start to end
        for (let i = 0; i < currentDayEvents.length; i++) {
          let cur = currentDayEvents[i];
          if (cur.id !== this.dragEvent.id && cur.start < this.dragEvent.current_drag && cur.end > this.dragEvent.current_drag) {
            let tempStart, tempEnd;
            tempStart = cur.start;
            tempEnd = cur.end;
            cur.start = this.dragEvent.start;
            cur.end = this.dragEvent.end;
            this.dragEvent.start = tempStart;
            this.dragEvent.end = tempEnd;
            break;
          }
        }
      } else {
        // travers end to start
        for (let i = currentDayEvents.length-1; i >= 0 ; i--) {
          let cur = currentDayEvents[i];
          if (cur.id !== this.dragEvent.id && cur.start < this.dragEvent.current_drag && cur.end > this.dragEvent.current_drag) {
            let tempStart, tempEnd;
            tempStart = cur.start;
            tempEnd = cur.end;
            cur.start = this.dragEvent.start;
            cur.end = this.dragEvent.end;
            this.dragEvent.start = tempStart;
            this.dragEvent.end = tempEnd;
            break;
          }
        }
      }
      currentDayEvents = _orderBy(this.calendarEvents.filter(event => event.date === this.dragEvent.date), 'start');
      let update = {};
      // update the order of the events and send to the server
      for (let i = 0; i < currentDayEvents.length; i++) {
        currentDayEvents[i].order = i+2;
        for (let j = 0; j < currentDayEvents[i].todoIds.length; j++) {
          update[currentDayEvents[i].todoIds[j]] = currentDayEvents[i].order;
        }
      }
      this.debounceSetOrder(update);
    },
    debounceCalculateOrder: _debounce(function () {
      this.calculateOrder();
    }, 25),
    debounceSetOrder: _debounce(function (args) {
      let req = JSON.stringify({
        key: sessionStorage.getItem("aes"),
        order: args
      })
      this.$http.post(
          Server_URL+'/auftragsbuch/planning/order',req
      ).then(this.responseTrap, this.responseError)
    }, 800),
    startDragEvent ({ event, timed }) {
      if (event && timed) {
        this.dragEvent = event
      }
    },
    startTime (tms) {
      const mouse = this.toTime(tms)
      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start
        this.dragTime = mouse - start
      }
    },
    mouseMove (tms) {
      const mouse = this.toTime(tms)
      if (this.dragEvent && this.dragTime !== null) {
        const newStartTime = mouse - this.dragTime
        if (this.dragEvent.current_drag !== this.roundTime(newStartTime)) {
          this.dragEvent.current_drag = this.roundTime(newStartTime)
          this.debounceCalculateOrder();
        }
      }
    },
    endDrag () {
      this.dragTime = null;
      if (this.dragEvent) {
        this.dragEvent.current_drag = undefined;
      }
      this.dragEvent = null;
    },
    cancelDrag () {
      this.dragTime = null;
      if (this.dragEvent) {
        this.dragEvent.current_drag = undefined;
      }
      this.dragEvent = null;
    },
    roundTime (time, down = true) {
      const roundTo = 1440 / this.countIntervals // minutes
      const roundDownTime = roundTo * 60 * 1000

      return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
    async upsertQuickTask(quickTask, selected) {
      if (quickTask.task_type === "task" || (quickTask.task_type === "tour" && !selected)) {
        let currentDate = new Date(this.date);
        let start, end;
        if (this.currentMode === 'month') {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        } else if (this.currentMode === 'week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (7 - day));
        } else if (this.currentMode === '5week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (5 - day));
        } else {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        }
        start.setDate(start.getDate() - this.taskFilter.timeInterval * 7);
        end.setDate(end.getDate() + this.taskFilter.timeInterval * 7);
        start = `${this.pad(start.getDate(), 2)}.${this.pad(start.getMonth() + 1, 2)}.${start.getFullYear()}`;
        end = `${this.pad(end.getDate(), 2)}.${this.pad(end.getMonth() + 1, 2)}.${end.getFullYear()}`;
        let req = {
          todos: [],
          deleted_ids: [],
          changed_ids: [],
          new_ids: [],
          key: sessionStorage.getItem("aes"),
          from_planning: true,
          selected_start_date: start,
          selected_end_date: end,
          planning_state: this.taskFilter.planned,
          module: (this.tasks_select_value === 'tasks' ? this.taskFilter.taskType : 'planning'),
          group_id: this.taskFilter.selectedKostMigr
        };

        if (quickTask.id) {
          let changedPlanning = _orderBy(quickTask.planned_for).join("") !== _orderBy(this.currentTask.planned_for).join("");
          let changedTodo = quickTask.task_description !== this.currentTask.task_description ||
              quickTask.from !== this.currentTask.from ||
              quickTask.till !== this.currentTask.till;
          if (!changedPlanning && !changedTodo) {
            // no changes
            return;
          }
          quickTask.task_description = await encryptAES(sessionStorage.getItem("aes"), quickTask.task_description)
          let res;
          for (let i = 0; i < this.events.length; i++) {
            if (this.events[i].todo_id === this.currentTask.id) {
              res = this.events.splice(i, 1);
              break;
            }
          }
          if (res.length === 0) {
            return;
          }
          res = res.concat(res[0].similar);
          for (let i = 0; i < res.length; i++) {
            let cur = res[i]
            if (quickTask.planned_for.indexOf(cur.user_id) === -1) {
              req.deleted_ids.push(cur.todo_id);
            }  else {
              // changed
              let todo = {
                id: cur.todo_id,
                task_id: quickTask.task_id,
                user_id: cur.user_id,
                todo_type: "ab",
                message: quickTask.task_description,
                from: quickTask.from,
                till: quickTask.till,
                order: quickTask.order,
                is_finished: cur.is_finished,
              }
              req.todos.push(todo);
              req.changed_ids.push(todo.id);
            }
          }
          // check for new ones
          for (let i = 0; i < quickTask.planned_for.length; i++) {
            let curUser = quickTask.planned_for[i];
            if (this.currentTask.planned_for.indexOf(curUser) === -1) {
              // new
              let todo = {
                id: v4(),
                task_id: quickTask.task_id,
                user_id: curUser,
                todo_type: "ab",
                message: quickTask.task_description,
                from: quickTask.from,
                till: quickTask.till,
                order: quickTask.order,
                is_finished: false,
              }
              req.todos.push(todo);
              req.new_ids.push(todo.id);
            }
          }
          this.showLoader();
          this.$http.post(
              Server_URL + '/auftragsbuch/data/av/todos/'+quickTask.task_id, req
          ).then(this.responseUpsertTaskEvent, this.responseError)
        } else {
          // create -> only new todos
          quickTask.task_description = await encryptAES(sessionStorage.getItem("aes"), quickTask.task_description)
          for (let i = 0; i < quickTask.planned_for.length; i++) {
            let todo = {
              id: v4(),
              task_id: quickTask.task_id,
              user_id: quickTask.planned_for[i],
              todo_type: "ab",
              message: quickTask.task_description,
              from: quickTask.from,
              till: quickTask.till,
              order: quickTask.order,
              is_finished: false,
            }
            req.todos.push(todo);
            req.new_ids.push(todo.id);
          }
          this.showLoader();
          this.$http.post(
              Server_URL + '/auftragsbuch/data/av/todos/'+quickTask.task_id, req
          ).then(this.responseUpsertTaskEvent, this.responseError)
        }
      } else if (quickTask.task_type === "quick") {
        if (quickTask.task_id) {
          for (let i = 0; i < this.events.length; i++) {
            if (this.events[i].todo_id === this.currentTask.id) {
              this.events.splice(i, 1);
              break;
            }
          }
          let req = quickTask;
          req.task_description = await encryptAES(sessionStorage.getItem("aes"), req.task_description)
          req.key = sessionStorage.getItem("aes");
          this.showLoader();
          this.$http.post(
              Server_URL + '/auftragsbuch/planning/quick_task', req
          ).then(this.responseUpsertEvent, this.responseError)
        } else {
          let req = quickTask;
          req.task_description = await encryptAES(sessionStorage.getItem("aes"), req.task_description)
          req.key = sessionStorage.getItem("aes");
          this.showLoader();
          this.$http.post(
              Server_URL + '/auftragsbuch/planning/quick_task', req
          ).then(this.responseUpsertEvent, this.responseError)
        }
      } else {
        // tour but we only have some tour tasks

        let currentDate = new Date(this.date);
        let start, end;
        if (this.currentMode === 'month') {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        } else if (this.currentMode === 'week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (7 - day));
        } else if (this.currentMode === '5week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (5 - day));
        } else {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        }
        start.setDate(start.getDate() - this.taskFilter.timeInterval * 7);
        end.setDate(end.getDate() + this.taskFilter.timeInterval * 7);
        start = `${this.pad(start.getDate(), 2)}.${this.pad(start.getMonth() + 1, 2)}.${start.getFullYear()}`;
        end = `${this.pad(end.getDate(), 2)}.${this.pad(end.getMonth() + 1, 2)}.${end.getFullYear()}`;
        let req = {
          todos: [],
          sub_todos: [],
          deleted_ids: [],
          changed_ids: [],
          new_ids: [],
          key: sessionStorage.getItem("aes"),
          from_planning: true,
          selected_start_date: start,
          selected_end_date: end,
          planning_state: this.taskFilter.planned,
          module: (this.tasks_select_value === 'tasks' ? this.taskFilter.taskType : 'planning'),
          group_id: this.taskFilter.selectedKostMigr,
          for_users: this.currentMitas,
        };
        if (quickTask.id === '') {
          // create new
          // create -> only new todos
          quickTask.task_description = await encryptAES(sessionStorage.getItem("aes"), quickTask.task_description)
          for (let i = 0; i < quickTask.planned_for.length; i++) {
            let todo = {
              id: v4(),
              task_id: quickTask.task_id,
              user_id: quickTask.planned_for[i],
              todo_type: "ab",
              message: quickTask.task_description,
              from: quickTask.from,
              till: quickTask.till,
              order: quickTask.order,
              is_finished: false,
            }
            req.todos.push(todo);
            req.new_ids.push(todo.id);
            for (let j = 0; j < selected.length; j++) {
              let subTodo = {
                id: v4(),
                task_id: selected[j].id,
                user_id: quickTask.planned_for[i],
                todo_type: "ab",
                message: selected[j].task_description,
                from: quickTask.from,
                till: quickTask.till,
                order: 0,
                is_finished: false,
              }
              req.sub_todos.push(subTodo);
              req.new_ids.push(subTodo.id);
            }
          }
          this.showLoader();
          this.$http.post(
              Server_URL + '/auftragsbuch/planning/tour_tasks/'+quickTask.task_id, req
          ).then(this.responseUpsertTourEvent, this.responseError)
        } else {
          let changedPlanning = _orderBy(quickTask.planned_for).join("") !== _orderBy(this.currentTask.planned_for).join("");
          let changedTodo = quickTask.task_description !== this.currentTask.task_description ||
              quickTask.from !== this.currentTask.from ||
              quickTask.till !== this.currentTask.till;
          if (!changedPlanning && !changedTodo) {
            // no changes
            return;
          }
          quickTask.task_description = await encryptAES(sessionStorage.getItem("aes"), quickTask.task_description)
          let res;
          for (let i = 0; i < this.events.length; i++) {
            if (this.events[i].todo_id === this.currentTask.id) {
              res = this.events.splice(i, 1);
              break;
            }
          }
          if (res.length === 0) {
            return;
          }
          let taskId = res[0].todo_type;
          res = res.concat(res[0].similar);
          for (let i = 0; i < res.length; i++) {
            let cur = res[i]
            if (quickTask.planned_for.indexOf(cur.user_id) === -1) {
              req.deleted_ids.push(cur.todo_id);
            }  else {
              // changed
              let todo = {
                id: v4(),
                task_id: taskId,
                user_id: cur.user_id,
                todo_type: "ab",
                message: quickTask.task_description,
                from: quickTask.from,
                till: quickTask.till,
                order: quickTask.order,
                is_finished: false,
              }
              req.todos.push(todo);
              req.new_ids.push(todo.id);
              let subTodo = {
                id: cur.todo_id,
                task_id: quickTask.task_id,
                user_id: cur.user_id,
                todo_type: "ab",
                message: quickTask.task_description,
                from: quickTask.from,
                till: quickTask.till,
                order: quickTask.order,
                is_finished: cur.is_finished,
              }
              req.sub_todos.push(subTodo);
              req.changed_ids.push(subTodo.id);
            }
          }
          // check for new ones
          for (let i = 0; i < quickTask.planned_for.length; i++) {
            let curUser = quickTask.planned_for[i];
            if (this.currentTask.planned_for.indexOf(curUser) === -1) {
              let todo = {
                id: v4(),
                task_id: taskId,
                user_id: curUser,
                todo_type: "ab",
                message: quickTask.task_description,
                from: quickTask.from,
                till: quickTask.till,
                order: quickTask.order,
                is_finished: false,
              }
              req.todos.push(todo);
              req.new_ids.push(todo.id);
              // new
              let subTodo = {
                id: v4(),
                task_id: quickTask.task_id,
                user_id: curUser,
                todo_type: "ab",
                message: quickTask.task_description,
                from: quickTask.from,
                till: quickTask.till,
                order: quickTask.order,
                is_finished: false,
              }
              req.sub_todos.push(subTodo);
              req.new_ids.push(subTodo.id);
            }
          }
          this.showLoader();
          this.$http.post(
              Server_URL + '/auftragsbuch/planning/tour_tasks/'+taskId, req
          ).then(this.responseUpsertTourEvent, this.responseError)
        }
      }
    },
    deleteQuickTask() {
      if (!this.currentTask) {
        return;
      }
      if (this.currentTask.task_type === 'quick') {
        for (let i = 0; i < this.events.length; i++) {
          if (this.events[i].todo_id === this.currentTask.id) {
            this.events.splice(i, 1);
            break;
          }
        }
        this.calculateCalendarEvents();
        this.showLoader();
        this.$http.delete(
            Server_URL + '/auftragsbuch/planning/quick_task/' + this.currentTask.task_id
        ).then(this.responseTrap, this.responseError)
      } else if (this.currentTask.task_type === "task" || this.currentTask.task_type === "tour") {
        let currentDate = new Date(this.date);
        let start, end;
        if (this.currentMode === 'month') {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        } else if (this.currentMode === 'week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (7 - day));
        } else if (this.currentMode === '5week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (5 - day));
        } else {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        }
        start.setDate(start.getDate() - this.taskFilter.timeInterval * 7);
        end.setDate(end.getDate() + this.taskFilter.timeInterval * 7);
        start = `${this.pad(start.getDate(), 2)}.${this.pad(start.getMonth() + 1, 2)}.${start.getFullYear()}`;
        end = `${this.pad(end.getDate(), 2)}.${this.pad(end.getMonth() + 1, 2)}.${end.getFullYear()}`;
        let req = {
          todos: [],
          deleted_ids: [],
          changed_ids: [],
          new_ids: [],
          key: sessionStorage.getItem("aes"),
          from_planning: true,
          selected_start_date: start,
          selected_end_date: end,
          planning_state: this.taskFilter.planned,
          module: (this.tasks_select_value === 'tasks' ? this.taskFilter.taskType : 'planning'),
          group_id: this.taskFilter.selectedKostMigr
        };
        let res;
        for (let i = 0; i < this.events.length; i++) {
          if (this.events[i].todo_id === this.currentTask.id) {
            res = this.events.splice(i, 1);
            break;
          }
        }
        if (res.length === 0) {
          return;
        }
        res = res.concat(res[0].similar);
        req.deleted_ids = res.map(item => item.todo_id);
        this.showLoader();
        this.$http.post(
            Server_URL + '/auftragsbuch/data/av/todos/'+this.currentTask.task_id, req
        ).then(this.responseUpsertTaskEvent, this.responseError)
      } else {
        let currentDate = new Date(this.date);
        let start, end;
        if (this.currentMode === 'month') {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        } else if (this.currentMode === 'week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (7 - day));
        } else if (this.currentMode === '5week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (5 - day));
        } else {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        }
        start.setDate(start.getDate() - this.taskFilter.timeInterval * 7);
        end.setDate(end.getDate() + this.taskFilter.timeInterval * 7);
        start = `${this.pad(start.getDate(), 2)}.${this.pad(start.getMonth() + 1, 2)}.${start.getFullYear()}`;
        end = `${this.pad(end.getDate(), 2)}.${this.pad(end.getMonth() + 1, 2)}.${end.getFullYear()}`;
        let req = {
          todos: [],
          deleted_ids: [],
          changed_ids: [],
          new_ids: [],
          key: sessionStorage.getItem("aes"),
          from_planning: true,
          selected_start_date: start,
          selected_end_date: end,
          planning_state: this.taskFilter.planned,
          module: (this.tasks_select_value === 'tasks' ? this.taskFilter.taskType : 'planning'),
          group_id: this.taskFilter.selectedKostMigr,
          for_users: this.currentMitas,

        };
        let res;
        for (let i = 0; i < this.events.length; i++) {
          if (this.events[i].todo_id === this.currentTask.id) {
            res = this.events.splice(i, 1);
            break;
          }
        }
        if (res.length === 0) {
          return;
        }
        res = res.concat(res[0].similar);
        req.deleted_ids = res.map(item => item.todo_id);
        this.showLoader();
        this.$http.post(
            Server_URL + '/auftragsbuch/planning/tour_tasks/'+this.currentTask.task_id, req
        ).then(this.responseUpsertTourEvent, this.responseError)
      }
    },
    debounceInput: _debounce(function (serach) {
      this.searchTasks = serach;
    }, 150),
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('item', JSON.stringify(item))
    },
    showTourOverView(id) {
      this.showLoader();
      this.$http.get(
          Server_URL + '/auftragsbuch/planning/tour/'+id
      ).then(this.responseOkTourOverviewData, this.responseError)
    },
    responseOkTourOverviewData(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.tourData = response.body.additions_tour_data;
        this.tour = response.body.tour;
        this.$nextTick(() => {
          this.$refs.tour_overview_dialog.show();
        });
      } else {
        window.location = Redirect_500;
      }
    },
    onDrop(evt, date, weekday, item) {
      this.tourData = [];
      this.currentTask = {};
      /*if (this.date.split('-') [1] !== date.split('-') [1]) {
        return;
      }*/
      if (!item) {
        item = JSON.parse(evt.dataTransfer.getData('item'))
      }
      this.possibleUsers = [];
      for (let i = 0; i < this.currentMitas.length; i++) {
        this.possibleUsers.push({id: this.currentMitas[i], name: this.getNameForId(this.currentMitas[i])});
      }
      // order by name
      this.possibleUsers = _orderBy(this.possibleUsers, 'name');
      // get the current order eg. how many events exist for this current day
      let currentDayEvents = this.calendarEvents.filter(event => event.date === date);
      // order always starts at 2
      let order = currentDayEvents.length + 2;
      if (this.tasks_select_value === "stamm") {
        this.currentTask = {
          id: '',
          augr: item.augr,
          aufisn: item.aufisn,
          legr: '',
          task_name: item.object,
          task_description: '',
          from: null,
          till: date,
          planned_for: this.possibleUsers.map(item => item.id),
          task_type: 'quick',
          order: order,
        }
        this.$nextTick(() => {
          this.$refs.quick_task_modal.show();
        });
      } else if (this.tasks_select_value === "tasks") {
        this.currentTask = {
          id: '',
          task_id: item.id,
          task_name: item.subject,
          task_description: item.description,
          from: null,
          till: date,
          planned_for: this.possibleUsers.map(item => item.id),
          task_type: 'task',
          order: order,
        }
        this.$nextTick(() => {
          this.$refs.quick_task_modal.show();
        });
      } else if (this.tasks_select_value === "tours") {
        this.currentTask = {
          id: '',
          task_id: item.id,
          task_name: item.subject,
          task_description: item.description,
          from: this.currentPredefFrom ? this.currentPredefFrom : null,
          till: date,
          planned_for: this.possibleUsers.map(item => item.id),
          task_type: 'tour',
          order: order,
        }
        this.currentPredefFrom = null;
        this.showLoader();
        this.$http.get(
            Server_URL + '/auftragsbuch/planning/tour/'+item.id
        ).then(this.responseOkTourData, this.responseError)
      } else {
        this.currentPredef = item;
        this.currentPredef.from = null;
        this.currentPredef.till = date;
        this.currentPredef.selectedKostMigr = null;
        this.currentPredef.automatic = true;
        this.$nextTick(() => {
          this.$refs.plan_predef_dialog.show();
        });
      }
    },
    responseOkTourData(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.tourData = response.body.additions_tour_data;
        this.$nextTick(() => {
          this.$refs.quick_task_modal.show();
        });
      } else {
        window.location = Redirect_500;
      }
    },
    async onPlanTour(tour) {
      this.currentPredefFrom = tour.from;
      this.currentPredef.till = tour.till;
      let req = {
        tour_name: tour.name,
        tour_description: await encryptAES(sessionStorage.getItem("aes"), tour.description),
        tour_date: tour.till + "T12:00:00Z",
        tour_legr: tour.legr_id,
        kost_migr: tour.selectedKostMigr,
        close_automatic: tour.automatic,
        from_planning: true,
      }
      this.$http.post(
          Server_URL + '/auftragsbuch/data/plan_predefined_tour/'+tour.id, req
      ).then(this.responsePlanTour, this.responseError)
    },
    responsePlanTour(response) {
      this.hideLoader();
      if (response.status === 200) {
        let res = response.body.tour;
        if (res && res.length) {
          this.resTour = res[0];
        } else {
          this.resTour = null;
        }
        this.tasks_select_value = "tours";
        this.onTaskSelectChange();
      } else {
        window.location = Redirect_500;
      }
    },
    moveDate(direction) {
      let curDate = new Date(this.date);
      switch (this.currentMode) {
        case 'day':
          this.date = new Date(curDate.setDate(curDate.getDate() + direction)).toISOString().substring(0, 10);
          break
        case 'month':
          this.date = new Date(curDate.setMonth(curDate.getMonth() + direction)).toISOString().substring(0, 10);
          break
        default:
          this.date = new Date(curDate.setDate(curDate.getDate() + (direction * 7))).toISOString().substring(0, 10);
      }
      this.focus = this.date;
    },
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
      // Return array of year and week number
      return weekNo;
    },
    getNotFilteredItems(l1, l2) {
      // concat both arrays
      let res = [...l1].concat([...l2]);
      // make unique
      res = res.filter((item, index) => res.indexOf(item) === index);

      for (let i = 0; i < this.filteredItems.length; i++) {
        res = res.filter(item => item !== this.filteredItems[i].id);
      }
      return res;

    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.migrs = response.body.migrs;
        this.mitas = response.body.mita;
        for (let migr in this.mitas) {
          for (let i = 0; i < this.mitas[migr].length; i++) {
            this.mitas[migr][i].name = this.getMitaNameForGischl(this.mitas[migr][i]);
          }
        }
        for (let i = 0; i < response.body.mita_flat.length; i++) {
          let mita = response.body.mita_flat[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
        }
        this.kosts = response.body.kosts;
        this.migr_map = response.body.migr_map;
        this.kostMigrMap = new Map();
        for (let i = 0; i < this.migrs.length; i++) {
          this.kostMigrMap.set("MIGR-"+this.migrs[i].gischl + "-", this.migrs[i].name);
        }
        for (let i = 0; i < this.kosts.length; i++) {
          this.kostMigrMap.set("KOST-"+this.kosts[i].gischl + "-", this.kosts[i].name);
        }
        for (let kost in this.migr_map) {
          for (let i = 0; i < this.migr_map[kost].length; i++) {
            this.kostMigrMap.set("MIGR-"+this.migr_map[kost][i].gischl + "-", this.migr_map[kost][i].name);
          }
        }
        this.holidays = response.body.holidays;
        console.log(this.holidays)
        for (let i = 0; i <  response.body.augrs.length; i++) {
          response.body.augrs[i].active = false;
        }
        this.augrs = response.body.augrs;
        this.stamms = response.body.stamms;
        let districtMap = new Set();

        for (let i = 0; i < this.augrs.length; i++) {
          if (this.stamms[this.augrs[i].gischl]) {
            for (let j = 0; j < this.stamms[this.augrs[i].gischl].length; j++) {
              if (this.stamms[this.augrs[i].gischl][j].district) {
                districtMap.add(this.stamms[this.augrs[i].gischl][j].district);
              }
            }
          }
        }
        this.districtSelect = Array.from(districtMap);
        this.legrs = _orderBy(response.body.legrs, 'name');
        this.bhStructure = response.body.bh_structure;
        this.possibleTabs = response.body.av_defs;
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    unselectMitas() {
      this.currentMitas = [];
      this.changeMitas();
    },
    sortedMigrs(kost) {
      return _orderBy(this.migr_map[kost], 'name');
    },
    sortedItems(migr) {
      return _orderBy(this.mitas[migr], 'name');
    },
    sortedStamms(augr) {
      if (!this.stamms[augr.gischl]) {
        return [];
      }
      return _orderBy(this.stamms[augr.gischl].filter(item => {
        if (!this.searchTasks && !this.selectedDistrict) {
          return this.stamms[augr.gischl];
        } else if (this.searchTasks && !this.selectedDistrict) {
          return item.object.toLowerCase().includes(this.searchTasks.toLowerCase());
        } else if (!this.searchTasks && this.selectedDistrict) {
          return item.district === this.selectedDistrict;
        } else {
          return item.object.toLowerCase().includes(this.searchTasks.toLowerCase()) && item.district === this.selectedDistrict;
        }
      }), 'object');
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    getEventColor(event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.dragEvent
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          :  event.color
    },
    getNameForId(id) {
      let res = JSON.parse(sessionStorage.getItem(id));
      if (res !== null) {
        return res.first_name + " " + res.surname;
      } else {
        if (this.kostMigrMap.has(id)) {
          return this.kostMigrMap.get(id);
        }
        return id;
      }
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    changeMitas() {
      if (this.currentMitas.length === 0) {
        //this.holidays = [];
        this.events = [];
        this.calculateCalendarEvents();
      } else {
        let currentDate = new Date(this.date);
        let start, end;
        if (this.currentMode === 'month') {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        } else if (this.currentMode === 'week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (7 - day));
        } else if (this.currentMode === '5week') {
          let day = currentDate.getDay();
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1);
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (5 - day));
        } else {
          start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
          end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        }
        start = `${start.getFullYear()}-${this.pad(start.getMonth() + 1, 2)}-${this.pad(start.getDate(), 2)}`
        end = `${end.getFullYear()}-${this.pad(end.getMonth() + 1, 2)}-${this.pad(end.getDate(), 2)}`
        //this.showLoader();
        let data = {
          from: start,
          till: end,
          for_users: this.currentMitas,
        }
        this.showLoader();
        this.$http.post(
            Server_URL + '/auftragsbuch/planning/events', data
        ).then(this.responseOkGetEvents, this.responseError)
      }
    },
    async responseOkGetEvents(response) {
      this.hideLoader();
      if (response.status === 200) {
        let events = response.body.events;
        let quick_events = response.body.quick_events;
        events = await decryptEvent(sessionStorage.getItem("aes"), events);
        quick_events = await decryptEvent(sessionStorage.getItem("aes"), quick_events);
        this.calculateEvents(events, quick_events);
        this.calculateCalendarEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    responseTrap(response) {
      this.hideLoader();
      if (response.status === 200) {

      } else {
        window.location = Redirect_500;
      }
    },
    async responseUpsertEvent(response) {
      this.hideLoader();
      if (response.status === 200) {
        let quick_events = response.body;
        quick_events = await decryptEvent(sessionStorage.getItem("aes"), quick_events);
        this.appendEvents([], quick_events);
        this.calculateCalendarEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    async responseUpsertTaskEvent(response) {
      this.hideLoader();
      if (response.status === 200) {
        let events = response.body.events;
        let resTasks = response.body.tasks;
        if (resTasks && resTasks.length > 0) {
          await this.decryptData(resTasks, true);
        } else {
          // delete the current task from the tasks
          for (let i = 0; i < this.tasks.length; i++) {
            if (this.tasks[i].id === this.currentTask.task_id) {
              this.tasks.splice(i, 1);
              break;
            }
          }
        }
        events = await decryptEvent(sessionStorage.getItem("aes"), events);
        this.appendEvents(events, []);
        this.calculateCalendarEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    async responseUpsertTourEvent(response) {
      this.hideLoader();
      if (response.status === 200) {
        let events = response.body.events;
        let quick_events = response.body.quick_events;
        let resTasks = response.body.tasks;
        if (resTasks && resTasks.length > 0) {
          await this.decryptData(resTasks, true);
        } else {
          // delete the current task from the tasks
          for (let i = 0; i < this.tasks.length; i++) {
            if (this.tasks[i].id === this.currentTask.task_id) {
              this.tasks.splice(i, 1);
              break;
            }
          }
        }
        events = await decryptEvent(sessionStorage.getItem("aes"), events);
        quick_events = await decryptEvent(sessionStorage.getItem("aes"), quick_events);
        this.calculateEvents(events, quick_events);
        this.calculateCalendarEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    calculateEvents(events, quickEvents) {
      let resEvents = [];
      let rest = [];
      while (events.length > 0) {
        let current = events.shift();
        rest = [];
        current.similar = [];
        for (let i = 0; i < events.length; i++) {
          let check = events[i];
          if (current.task_id === check.task_id && current.todo_message === check.todo_message
              && current.from === check.from && current.till === check.till) {
            current.similar.push(check);
          } else {
            rest.push(check);
          }
        }
        resEvents.push(current);
        events = rest;
      }
      rest = [];
      while (quickEvents.length > 0) {
        let current = quickEvents.shift();
        rest = [];
        current.similar = [];
        for (let i = 0; i < quickEvents.length; i++) {
          let check = quickEvents[i];
          if (current.task_id === check.task_id && current.todo_message === check.todo_message
              && current.from === check.from && current.till === check.till) {
            current.similar.push(check);
          } else {
            rest.push(check);
          }
        }
        resEvents.push(current);
        quickEvents = rest;
      }
      this.events = resEvents;
    },
    appendEvents(events, quickEvents) {
      let resEvents = [];
      let rest = [];
      while (events && events.length > 0) {
        let current = events.shift();
        rest = [];
        current.similar = [];
        for (let i = 0; i < events.length; i++) {
          let check = events[i];
          if (current.task_id === check.task_id && current.todo_message === check.todo_message
              && current.from === check.from && current.till === check.till) {
            current.similar.push(check);
          } else {
            rest.push(check);
          }
        }
        resEvents.push(current);
        events = rest;
      }
      rest = [];
      while (quickEvents && quickEvents.length > 0) {
        let current = quickEvents.shift();
        rest = [];
        current.similar = [];
        for (let i = 0; i < quickEvents.length; i++) {
          let check = quickEvents[i];
          if (current.task_id === check.task_id && current.todo_message === check.todo_message
              && current.from === check.from && current.till === check.till) {
            current.similar.push(check);
          } else {
            rest.push(check);
          }
        }
        resEvents.push(current);
        quickEvents = rest;
      }
      this.events.push(...resEvents);
    },
    calculateCalendarEvents() {
      let res = new Map();
      for (let i = 0; i < this.events.length; i++) {
        let current = this.events[i];
        let start;
        let end = new Date(current.till);
        if (current.from === null) {
          start = new Date(current.till);
        } else {
          start = new Date(current.from);
        }
        let plannedFor = [];
        let finishedBy = [];
        let todoIds = [current.todo_id];
        if (current.is_finished) {
          finishedBy.push(this.getNameForId(current.user_id));
        } else {
          plannedFor.push(this.getNameForId(current.user_id));
        }
        for (let j = 0; j < current.similar.length; j++) {
          todoIds.push(current.similar[j].todo_id);
          if (current.similar[j].is_finished) {
            finishedBy.push(this.getNameForId(current.similar[j].user_id));
          } else {
            plannedFor.push(this.getNameForId(current.similar[j].user_id));
          }
        }
        let initialStart = new Date(start.getTime());
        while (start <= end) {
          if (!this.compareDate(start, initialStart) && !this.compareDate(start, end) &&
              (start.getDay() === 0 || start.getDay() === 6 || this.holidays[start.toISOString().split('T')[0]])) {
            start.setDate(start.getDate() + 1);
            continue;
          }
          let event = {
            id: current.todo_id + '||' + start.getTime(),
            name: current.task_subject,
            description: current.todo_message,
            task_message: current.task_message,
            type: current.task_type,
            date: `${start.getFullYear()}-${this.pad(start.getMonth() + 1, 2)}-${this.pad(start.getDate(), 2)}`,
            color: plannedFor.length === 0 ? finishedColor : (finishedBy.length === 0 ? normalColor : partlyColor),
            timed: true,
            todo_type: current.todo_type,
            plannedFor: plannedFor,
            finishedBy: finishedBy,
            todoIds: todoIds,
            order: current.order,
          }
          if (res.has(event.date)) {
            res.get(event.date).push(event);
          } else {
            res.set(event.date, [event]);
          }
          start.setDate(start.getDate() + 1);
        }
      }
      let resEvents = [];
      let maxCountPerDay = 0;
      for (let [key, value] of res) {
        if (value.length > maxCountPerDay) {
          maxCountPerDay = value.length;
        }
      }
      let minutesPerStep = 1440 / Math.max(maxCountPerDay, 6);
      for (let [key, value] of res) {
        let start = new Date(`${value[0].date}T00:00:00`)
        // order value by order
        value = _orderBy(value, 'order');
        // add minutes to start
        for (let i = 0; i < value.length; i++) {
          let event = value[i];
          event.order = i+1;
          event.start = new Date(start.getTime() + i * minutesPerStep * 60000);
          event.end = new Date(start.getTime() + (i + 1) * minutesPerStep * 60000);
          if (event.end > new Date(`${value[0].date}T23:59:59`)) {
            event.end = new Date(`${value[0].date}T23:59:59`);
          }
          resEvents.push(event);
        }
      }

      this.calendarEvents =  resEvents;
    },
    compareDate(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() &&
          d1.getMonth() === d2.getMonth() &&
          d1.getDate() === d2.getDate();
    },
    onMitaClicked(mitaId, mitaGroup, e) {
      if (e.shiftKey && mitaGroup !== 'migrs' && mitaGroup !== 'kosts') {
        if (this.currentMitas.length === 0) {
          this.currentMitas = [mitaId];
        } else {
          let sorted
          if (mitaGroup === "filteredItems") {
            sorted = this.filteredItems;
          } else {
            sorted = this.sortedItems(mitaGroup);
          }
          let indexA, indexB
          let lastMitaId = this.currentMitas[this.currentMitas.length - 1];
          for (let i = 0; i < sorted.length; i++) {
            if (sorted[i].bis_id+'-' === mitaId) {
              indexA = i;
            } else if (sorted[i].bis_id+'-' === lastMitaId) {
              indexB = i;
            }
          }
          let indexFrom = Math.min(indexA, indexB);
          let indexTo = Math.max(indexA, indexB);
          for (let i = indexFrom; i < indexTo + 1; i++) {
            let cur = sorted[i].bis_id+'-';
            if (this.currentMitas.indexOf(cur) === -1) {
              this.currentMitas.push(cur)
            }
          }
        }
      } else {
        let index = this.currentMitas.indexOf(mitaId);
        if (index === -1) {
          this.currentMitas.push(mitaId);
        } else {
          this.currentMitas.splice(index, 1);
        }
      } /*else {
        let index = this.currentMitas.indexOf(mitaId);
        if (index === -1) {
          this.currentMitas = [mitaId];
        } else {
          this.currentMitas = [];
        }
      }*/
      this.changeMitas()
    },
    isFuture(day, present, month, year) {
      if (present) {
        return false
      }
      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      let date = new Date(year, month - 1, day);
      return date > today;
    },
    onBack() {
      window.history.back();
    },
    clearSearch() {
      this.search = "";
      //this.unselectMitas();
    },
    setDate(date) {
      if (this.currentMode === 'month') {
        date = date + "-01";
      }
      this.date = date;
      this.$refs.dialog.save(date);
      this.focus = date;
    },
    pad(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    },
  },
}
</script>
<style lang="scss">

.v-calendar .v-event {
  pointer-events: none;
}

.clickable-month {
  pointer-events: auto !important;
  padding-left: 4px;
  padding-right: 4px;
}

.clickable {
  pointer-events: auto !important;
  padding: 6px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}

.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

</style>

<style scoped lang="scss">

.col {
  padding: 12px;
}

.row {
  flex: 1 1 auto;
}

.v-list-item-group .v-list-item--active {
  background-color: #63c2de;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

::v-deep .saldo input {
  font-weight: 500;
}

::v-deep .pos input {
  color: green !important;
}

::v-deep .neg input {
  color: red !important;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.zero {
  background-color: rgb(240, 230, 140) !important;
  border-color: rgb(240, 230, 140) !important;
}

.remove-background {
  background-color: transparent !important;
}

::v-deep  .v-list-group__header {
  padding: 0 4px !important;
}

::v-deep .v-calendar-daily__intervals-body {
  display: none;
}

::v-deep .v-calendar-daily__intervals-head {
  display: none;
}

::v-deep .five-week div.v-calendar-daily_head-day:nth-child(7) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily_head-day:nth-child(8) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily__day:nth-child(7) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily__day:nth-child(8) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .v-calendar .v-btn--fab.v-size--default {
  width: 28px;
  height: 28px;
}

::v-deep .v-calendar .v-btn--fab.v-size--default.blue {
  background-color: rgb(99, 194, 222) !important;
  border-color: rgb(99, 194, 222) !important;
}

::v-deep .v-calendar-daily__pane {
  min-height: 100% !important;
}

.my-filter {
  height: 100%; width: 100%;
}

::v-deep .my-filter>span {
  color: white;
}

::v-deep .my-filter.inactive>span {
  color: rgba(0, 0, 0, 0.87);
}

.my-filter:after {
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
  border-width: thin 0 0 0;
  bottom: -1px;
  content: "";
  left: 0;
  position: absolute;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.event-description {
  flex: 0 0 auto;
  overflow: hidden;
  width: 100%;
  white-space: normal;
  word-break: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  margin-bottom: 2px;
}

.planned-for {
  margin-top: 1px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: normal;
}

.event-extended {
  flex: 0 0 auto;
  margin-bottom: 4px
}

::v-deep .v-list-group__header__prepend-icon {
    margin-right: 0px  !important;
    margin-top: 6px  !important;
}

::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 18px !important;
}

.unselectable-text {
  -webkit-user-select: none !important; /* Safari */
  -moz-user-select: none !important; /* Firefox */
  -ms-user-select: none !important; /* IE10+/Edge */
  user-select: none !important; /* Standard */
}

::v-deep .v-calendar .v-event-timed-container {
  margin: 2px !important;
}

::v-deep .v-list-item__action {
  margin: 6px 0;
}

::v-deep .v-list-item__content {
  padding: 6px 0;
}

::v-deep .v-list-item {
  min-height: 38px;
  transform: translate(0, 0);
  padding: 0 10px;
}

::v-deep .v-list-item__icon {
  margin: 0px 0;
}

::v-deep .v-list {
  padding: 0px;
}

::v-deep .v-list--rounded.v-list--two-line .v-list-item {
  border-radius: 8px !important;
}

::v-deep .v-list--rounded.v-list--two-line .v-list-item::before {
  border-radius: 8px !important;
}

.rounded {
  border-radius: 8px !important;
}

.rounded::before {
  border-radius: 8px !important;
}

::v-deep .app-body {
  overflow: hidden;
}

</style>
